import request from "@/utils/request.js";

// 修改昵称
export const changeNickname = (nickname) => {
  return request.put(`/admin/nickname?nickname=${nickname}`);
};

// 修改密码
export const changePassword = (query_params) => {
  return request.put(
    `/admin/nicknamePassword?password=${query_params.password}&passwordOld=${query_params.passwordOld}`
  );
};

// 轮询微信绑定状态
export const api_isBindWechat = () => {
  return request.put(`/admin/isBindWechat`);
};

// 俱乐部-修改申请审核设置
export const updateClubRequireApproval = (updateData) => {
  return request.put(`/club/${updateData.id}/require-approval?requireApproval=${updateData.requireApproval}`);
};

// 俱乐部-修改报名人员名单可见设置
export const updateClubParticipantVisible = (updateData) => {
  return request.put(`/club/${updateData.id}/participant-visible?participantVisible=${updateData.participantVisible}`);
};

// 俱乐部-获取配置信息
export const getClubInfo = (clubId) => {
  return request.get(`/club/${clubId}/config`)
}
